"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 4.25a.7.7 0 0 1 .7-.7h6.2a.7.7 0 0 1 .436.152l1.875 1.49H21.3a.7.7 0 0 1 .7.7V19.75a.7.7 0 0 1-.7.7H2.7a.7.7 0 0 1-.7-.7zm1.4.7v14.1h17.2V6.593h-9.633a.7.7 0 0 1-.436-.152L8.656 4.95z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.616 8.239a.6.6 0 0 1 .768 0l1.987 1.653a.6.6 0 0 1 0 .922l-1.987 1.653a.6.6 0 0 1-.768 0L9.63 10.814a.6.6 0 0 1 0-.922zm-.665 2.114 1.049.872 1.05-.872L12 9.48zm-2.647.53a.6.6 0 0 1 .767 0l1.988 1.653a.6.6 0 0 1 0 .923L9.07 15.11a.6.6 0 0 1-.767 0l-1.987-1.65a.6.6 0 0 1 0-.923zm6.625 0a.6.6 0 0 1 .767 0l1.988 1.653a.6.6 0 0 1 0 .923l-1.988 1.652a.6.6 0 0 1-.767 0L12.94 13.46a.6.6 0 0 1 0-.923zm-7.29 2.114 1.048.873 1.05-.873-1.05-.872zm6.624 0 1.05.873 1.049-.873-1.05-.872zM9.63 15.181l1.987-1.653a.6.6 0 0 1 .768 0l1.987 1.652a.6.6 0 0 1 0 .923l-1.987 1.653a.6.6 0 0 1-.768 0L9.63 16.103a.6.6 0 0 1 0-.923m1.322.46 1.049.873 1.05-.872-1.05-.873z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WorkAppFolderIcon24.js.map